<template>
  <div>
    <!--
    <request :method="request.method" :params="request.params" #default="{ loading, error }" v-model="response">
      <content-spinner v-if="loading" class="ma3"/>
      <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
      <div v-else>
        {{ response }}
      </div>
    </request>
    -->

    <search-select
      class="ma2"
      :options="$store.getters['dict/currencies']"
      v-model="currency"
      placeholder="валюта"
      :search-enabled="false"
      bg="dark"
    ></search-select>

    <search-select
      class="ma2"
      :options="$store.getters['dict/units']"
      v-model="unit"
      placeholder="единица измерения"
      :search-enabled="false"
      bg="dark"
    ></search-select>

    <online-search-select
      :searchFunction="ossSearchProduct"
      v-model="ossValueProduct"
      placeholder="товар"
      class="ma2"
      bg="dark"
    />

    <online-search-select
      :searchFunction="ossSearchCompany"
      v-model="ossValueCompany"
      placeholder="компания"
      class="ma2"
      bg="dark"
    />

    <online-search
      :searchFunction="ossSearchProduct"
      @selected="productSelected"
      placeholder="добавить товар"
      class="ma2"
      bg="dark"
    />
    <ul class="list ma0 pa0">
      <li v-for="(product, index) in products" :key="index" class="pa2">
        {{ product.name }}
      </li>
    </ul>

  </div>
</template>

<script>
// import Request from '@/components/Request.vue'
// import ContentSpinner from '@/components/common/ContentSpinner.vue'
import SearchSelect from '@/components/ui/SearchSelect.vue'
import OnlineSearchSelect from '@/components/ui/OnlineSearchSelect.vue'
import OnlineSearch from '@/components/ui/OnlineSearch.vue'
import { DataService } from '@/services/DataService.js'

export default {
  components: {
    // Request,
    // ContentSpinner
    SearchSelect,
    OnlineSearchSelect,
    OnlineSearch
  },
  data () {
    return {
      request: {
        method: 'getProducts',
        params: {
          filter: {
            name: 'труба'
          },
          offset: 0,
          limit: 10
        }
      },
      response: null,
      unit: null,
      currency: null,
      ossValueProduct: null,
      ossSearchProduct: function (value) {
        const params = {
          filter: { name: value },
          offset: 0,
          limit: 50
        }
        return DataService.getProducts(params)
          .then(({ data: { product: { data, totalCount } } }) => {
            return {
              items: data ? data.map(p => ({ id: p.id, name: p.name })) : []
            }
          })
      },
      ossValueCompany: null,
      ossSearchCompany: function (value) {
        const params = {
          filter: { title: value },
          offset: 0,
          limit: 50
        }
        return DataService.getCompanies(params)
          .then(({ data: { company: { data, totalCount } } }) => {
            return {
              items: data ? data.map(c => ({ id: c.id, name: c.title })) : []
            }
          })
      },
      products: []
    }
  },
  methods: {
    productSelected (product) {
      this.products = [product, ...this.products]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
